import populate from 'coact/populate'


module.exports = next => (ctx) => next(ctx).then((response) => {
  const { model, modelviews: { views }, name } = ctx
  const { data: docs } = response

  const viewSchema = views[name] && views[name].schema
  const schema = viewSchema || model.schema()

  // TODO only populate keys in `populate`

  return populate(ctx.modelviews, schema, docs).then(data => ({
    ...response,
    data,
  }))
})



// WEBPACK FOOTER //
// ./src/views/middlewares/populate.js